import { render, staticRenderFns } from "./RolesV4.vue?vue&type=template&id=5c01387f&scoped=true"
import script from "./RolesV4.vue?vue&type=script&lang=js"
export * from "./RolesV4.vue?vue&type=script&lang=js"
import style0 from "./RolesV4.vue?vue&type=style&index=0&id=5c01387f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c01387f",
  null
  
)

export default component.exports